module.exports = __webpack_public_path__ + "img/1.bc5dbd07.png";